import { Integration_Handler_Names_Enum } from '@main/graphql/types.generated';
import { z } from 'zod/v4';

import { IntegrationConfig } from '../../../../../../lib';
import { JiraService } from '../../service';

export type IssuesExportCsvConfig = typeof IssuesExportCsvConfig._.Config;

export const IssuesExportCsvConfig = IntegrationConfig.make({
  service: JiraService,
  name: Integration_Handler_Names_Enum.IssuesExportCsv,
  configSchema: z.object({
    jqlQuery: z.string().min(1),
    jqlQueryCheck: z.string().optional(),
    fieldIds: z.array(z.string().min(1)).optional(),
  }),
});
